import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { MimshakData } from "../../interfaces/DTO/mimshakData";
import { formatCurrency } from "../../utils/namesFormater";
import { formatProductTypeUniversal } from "../../utils/productTypeUniversalFormatter";
import { formatHandlerCodeUniversal } from "../../utils/handlerCodeUniversalFormatter";

interface Props {
  mimshak: MimshakData;
}

const TransferSourceInfo: React.FC<Props> = ({ mimshak }) => {
  if (!mimshak.policy_number?.startsWith("transfered-")) return null;

  const sourceTransfer = mimshak.data?.products?.[0]?.policies_or_accounts?.[0]?.funds_transfer?.[0];

  return (
    <Box mt={2} mb={1} p={1.5} sx={{ bgcolor: "grey.100", borderRadius: 1, borderRight: "3px solid", borderColor: "warning.main" }}>
      <Typography variant="caption" color="text.secondary" display="block" fontWeight="bold" mb={0.5}>
        מקור הניוד
      </Typography>
      <Stack spacing={0.5}>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="caption" color="text.secondary">יצרן מקור:</Typography>
          <Typography variant="caption" fontWeight="bold">
            {formatHandlerCodeUniversal(sourceTransfer?.transferring_corporation ?? mimshak.handler_code)}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="caption" color="text.secondary">פוליסת מקור:</Typography>
          <Typography variant="caption" fontWeight="bold">
            {sourceTransfer?.transferring_fund_name ?? mimshak.policy_number.replace(/^transfered-/, "")}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="caption" color="text.secondary">סוג מוצר מקור:</Typography>
          <Typography variant="caption" fontWeight="bold">
            {formatProductTypeUniversal(sourceTransfer?.transferring_fund_id ?? mimshak.product_type)}
          </Typography>
        </Stack>
        {sourceTransfer?.deposit_amount_paid != null && (
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="caption" color="text.secondary">סכום מועבר:</Typography>
            <Typography variant="caption" fontWeight="bold">{formatCurrency(sourceTransfer.deposit_amount_paid)}</Typography>
          </Stack>
        )}
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="caption" color="text.secondary">מזהה קופה:</Typography>
          <Typography variant="caption" color="text.secondary">{mimshak.policy_number}</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default TransferSourceInfo;
